'use strict';

/* global $ */

let settings = {
    selector: '.js-contacts',
    itemSelector: '.js-contacts__additional-item',
    linkSelector: '.js-contacts__additional-link',
    textSelector: '.js-contacts__additional-text'
};

class Contacts {
    constructor(options) {
        this.opt = $.extend({}, settings, options);
        this.init();
    }
    init() {
        console.log('[ Contacts/init ]');

        let $block = $(this.opt.selector);
        if ($block.length) {
            let $items = $block.find(this.opt.itemSelector);

            for (let i = 0; i < $items.length; i ++) {
                let $item = $items.eq(i);

                let $link = $item.find(this.opt.linkSelector),
                    $text = $item.find(this.opt.textSelector);

                $link.on('click', function(e) {
                    e.preventDefault();

                    $text.fadeToggle();
                });
            }
        }
    }
}


export {
    Contacts
};
